import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps, ReactNode } from "react";

// Wraps a Heroicons 20/solid glyph (MIT, https://github.com/tailwindlabs/heroicons) as a Hopper icon, so it takes the
// same `size` and `color` props, and fills the same Button slot, as the Hopper icons beside it. Hopper draws each size
// from its own artboard; these scale the one 20px artboard to its 16, 24 and 32px sizes.
const atSize = (size: number, glyph: ReactNode) => {
    const HeroGlyph = (props: ComponentProps<"svg">) => (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="currentColor" {...props}>
            {glyph}
        </svg>
    );

    return HeroGlyph;
};

export const createHeroIcon = (glyph: ReactNode, displayName: string) =>
    createIcon(atSize(16, glyph), atSize(24, glyph), atSize(32, glyph), displayName);
